import React from "react";
import { Breadcrumb } from "antd";
import { HomeOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

export const BreadCrumb = ({ current }) => (
  <div className={"breadcrumb"}>
    <Breadcrumb
      items={[
        {
          key: "home",
          title: <Link to="/"><HomeOutlined className={"icon icon__home"} /></Link>,
        },
        {
          key: "current",
          title: <strong>{current}</strong>,
        },
      ]}
    />
  </div>
);

export default BreadCrumb;
